import request from '@utils/request.js'

export function getProjectIdsByUser (parameter) {
    return request({
      url: '/train/rest/project/get_project_id/'+`${parameter}`,
      method: 'get'
    })
  }
  export function setAuth(parameter){
    return request({
      url: '/train/rest/project/set_auth',
      method: 'post',
      data: parameter
    })
  }
  export function getStatistics(){
    return request({
      url:'/train/rest/project/get_statistics',
      method:'get'
    })
  }
  export function getProject(parameter){
    return request({
        url: '/train/rest/project/get/'+`${parameter}`,
        method: 'get'
      })
  }
  export function removeProject(parameter){
    return request({
        url: '/train/rest/project/remove',
        method: 'post',
        data: parameter
      })
  }
  export function updateProject(parameter){
    return request({
        url: '/train/rest/project/update',
        method: 'post',
        data: parameter
      })
  }
  export function addProject(parameter){
    return request({
        url: '/train/rest/project/add',
        method: 'post',
        data: parameter
      })
  }
  export function getProjectPageList (parameter) {
    return request({
      url: '/train/rest/project/get_page',
      method: 'get',
      params: parameter
    })
  }
  export function getAllProject(parameter){
    return request({
        url: '/train/rest/project/get_all',
        method: 'get'
      })
  }
  export function createDownload(parameter){
    return request({
      url: '/train/rest/download_task/create_download_task',
      method: 'post',
      data: parameter
    })
  }
  export function getDownload(parameter){
    return request({
      url: '/train/rest/download_task/get_download_task_page',
      method: 'get',
      params: parameter
    })
  }

  export function getlist(parameter){
    return request({
      url: '/train/rest/network_model/get_list',
      method: 'get',
      params: parameter
    })
  }

  export function uploader(parameter){
    return request({
      url: '/train/rest/file2/upload_resource_base64',
      method: 'post',
      data: parameter
    })
  }

  export function getError(parameter){
    return request({
      url: '/train/rest/task/get_break_error/' + `${parameter}`,
      method: 'get',
    })
  }